// /unsubscribe — página pública para procesar opt-out de emails.
// Query params: ?email=xxx&categoria=remitos|marketing|notificaciones|todos

import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { supabase } from '../lib/supabase'

const CATEGORIA_LABEL = {
  todos: 'todas las notificaciones',
  remitos: 'remitos de entrega',
  marketing: 'novedades y promociones',
  notificaciones: 'notificaciones operativas',
}

export default function Unsubscribe() {
  const [params] = useSearchParams()
  const email = params.get('email') || ''
  const categoriaInicial = params.get('categoria') || 'todos'
  const [categoria, setCategoria] = useState(categoriaInicial)
  const [motivo, setMotivo] = useState('')
  const [estado, setEstado] = useState('idle') // idle | procesando | ok | err
  const [error, setError] = useState(null)

  async function confirmar() {
    if (!email) { setError('Falta el email'); setEstado('err'); return }
    setEstado('procesando')
    setError(null)
    const { error: e } = await supabase.rpc('procesar_unsubscribe', {
      p_email: email,
      p_categoria: categoria,
      p_motivo: motivo || null,
    })
    if (e) { setError(e.message); setEstado('err'); return }
    setEstado('ok')
  }

  return (
    <div style={{
      minHeight: '100vh', background: '#F1F5F9', display: 'flex',
      alignItems: 'center', justifyContent: 'center', padding: 20,
      fontFamily: '"Helvetica Neue", Inter, Arial, sans-serif',
    }}>
      <div style={{
        maxWidth: 480, width: '100%', background: '#fff', borderRadius: 14,
        padding: 32, boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
      }}>
        <div style={{ fontSize: 28, fontWeight: 900, color: '#1A3461', letterSpacing: '-0.02em', marginBottom: 4 }}>
          limp<span style={{ color: '#00A8B5' }}>a</span>ck
        </div>
        <div style={{ fontSize: 10.5, color: '#64748B', fontWeight: 700, letterSpacing: '0.06em', textTransform: 'uppercase' }}>
          Cancelar notificaciones
        </div>

        {estado === 'ok' ? (
          <>
            <div style={{ margin: '28px 0 16px', padding: '18px 20px', background: '#D1FAE5', color: '#065F46', borderRadius: 10, fontSize: 14, lineHeight: 1.5 }}>
              ✓ Listo. No vas a recibir más <strong>{CATEGORIA_LABEL[categoria]}</strong> en <strong>{email}</strong>.
            </div>
            <p style={{ fontSize: 13, color: '#64748B', lineHeight: 1.5 }}>
              Si cambiás de opinión, escribinos a <a href="mailto:hola@limpack.uy" style={{ color: '#00A8B5' }}>hola@limpack.uy</a> y te reactivamos.
            </p>
          </>
        ) : estado === 'err' ? (
          <>
            <div style={{ margin: '28px 0 16px', padding: '18px 20px', background: '#FEE2E2', color: '#991B1B', borderRadius: 10, fontSize: 14 }}>
              No pudimos procesar la baja: {error}
            </div>
            <p style={{ fontSize: 13, color: '#64748B', lineHeight: 1.5 }}>
              Contactanos a <a href="mailto:hola@limpack.uy" style={{ color: '#00A8B5' }}>hola@limpack.uy</a> y lo hacemos manual.
            </p>
          </>
        ) : (
          <>
            <p style={{ margin: '22px 0 8px', fontSize: 14, color: '#334155', lineHeight: 1.5 }}>
              Vas a cancelar la recepción de emails de Limpack a:
            </p>
            <div style={{ padding: '10px 14px', background: '#F8F6F1', borderRadius: 8, fontWeight: 700, color: '#1A3461', fontSize: 14, marginBottom: 20 }}>
              {email || '(sin email)'}
            </div>

            <label style={{ display: 'block', marginBottom: 16 }}>
              <div style={{ fontSize: 11, fontWeight: 800, color: '#64748B', textTransform: 'uppercase', letterSpacing: '.06em', marginBottom: 6 }}>Qué querés cancelar</div>
              <select
                value={categoria}
                onChange={e => setCategoria(e.target.value)}
                style={{ width: '100%', padding: '10px 12px', fontSize: 14, border: '1.5px solid #E2E8F0', borderRadius: 8, fontFamily: 'inherit', background: '#fff' }}
              >
                <option value="remitos">Solo remitos de entrega</option>
                <option value="marketing">Solo marketing y promos</option>
                <option value="notificaciones">Solo notificaciones operativas</option>
                <option value="todos">Todo (no recibir más nada)</option>
              </select>
            </label>

            <label style={{ display: 'block', marginBottom: 20 }}>
              <div style={{ fontSize: 11, fontWeight: 800, color: '#64748B', textTransform: 'uppercase', letterSpacing: '.06em', marginBottom: 6 }}>Motivo (opcional)</div>
              <textarea
                value={motivo}
                onChange={e => setMotivo(e.target.value)}
                rows={2}
                placeholder="Contanos por qué te vas — nos ayuda a mejorar."
                style={{ width: '100%', padding: '10px 12px', fontSize: 13, border: '1.5px solid #E2E8F0', borderRadius: 8, fontFamily: 'inherit', resize: 'vertical' }}
              />
            </label>

            <button
              onClick={confirmar}
              disabled={estado === 'procesando' || !email}
              style={{
                width: '100%', padding: '12px 16px', border: 0, borderRadius: 8,
                background: estado === 'procesando' ? '#94A3B8' : '#DC2626',
                color: '#fff', fontSize: 14, fontWeight: 700, cursor: 'pointer',
                fontFamily: 'inherit',
              }}
            >
              {estado === 'procesando' ? 'Procesando…' : 'Confirmar cancelación'}
            </button>

            <p style={{ fontSize: 11, color: '#94A3B8', lineHeight: 1.5, marginTop: 16, textAlign: 'center' }}>
              Nunca dejamos de enviar comunicaciones legales (facturas, avisos regulatorios).
            </p>
          </>
        )}
      </div>
    </div>
  )
}
